import { Routes, Route } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Button, Container, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

import LandingPage from './pages/LandingPage';
import ChannelManagementPage from './pages/ChannelManagementPage';
import VideoPlayerPage from './pages/VideoPlayerPage';
import LoginPage from './components/auth/LoginPage';
import { useAuth } from './contexts/AuthContext';
import { useTheme } from './contexts/ThemeContext';

function App() {
  const { isAuthenticated, authRequired, logout } = useAuth();
  const { mode, toggleColorMode } = useTheme();

  if (authRequired && !isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Tube Me Up
          </Typography>
          <Button
            color="inherit"
            component={RouterLink}
            to="/"
            startIcon={<HomeIcon />}
          >
            Home
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/channels"
            startIcon={<SettingsIcon />}
          >
            Channels
          </Button>
          <IconButton color="inherit" onClick={toggleColorMode} title={mode === 'dark' ? 'Light mode' : 'Dark mode'}>
            {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
          {authRequired && (
            <IconButton color="inherit" onClick={logout} title="Logout">
              <LogoutIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ mt: 4, mb: 4, flex: 1 }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/channels" element={<ChannelManagementPage />} />
          <Route path="/watch/:videoId" element={<VideoPlayerPage />} />
        </Routes>
      </Container>

      <Box
        component="footer"
        sx={{
          py: 2,
          px: 2,
          mt: 'auto',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[200]
              : theme.palette.grey[800],
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body2" color="text.secondary" align="center">
            Tube Me Up - Custom YouTube Client
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}

export default App;
